export enum ProjectDuplicateStatusGq {
  INACTIVE = 'INACTIVE',
  QUEUED_FOR_API_CALLS = 'QUEUED_FOR_API_CALLS',
  CREATING_API_CALLS = 'CREATING_API_CALLS',
  QUEUED_FOR_STAT_DUPLICATES = 'QUEUED_FOR_STAT_DUPLICATES',
  QUEUED_FOR_LLM = 'QUEUED_FOR_LLM',
  COMPLETED = 'COMPLETED',
}
